class NewsLetterForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.formPopup = this.form?.querySelector('#newsletter-popup');
    this.newsletterFormFooter = document.querySelector('.newsletter-footer_cta');
    this.closeNewsletterDrawer = this.form?.closest('side-drawer');
    this.drawerToOpen = document.querySelector('.sidedrawer-container');
  }

  connectedCallback() {
    if (!this.form) return;

    this.setupBirthdatePlaceholder();
    this.setupDrawerCloseCookie();
    this.setupPopupTimer();
    this.prefillEmailFromQuery();
    this.setupInvalidScroll();
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  setupInvalidScroll() {
    this.form.addEventListener('invalid', (e) => {
      const field = e.target;
      if (!field || this._invalidScrollScheduled) return;
      this._invalidScrollScheduled = true;
      requestAnimationFrame(() => {
        this._invalidScrollScheduled = false;
        const first = this.form.querySelector(':invalid');
        if (!first) return;
        const rect = first.getBoundingClientRect();
        const offset = window.innerHeight / 2 - rect.height / 2;
        window.scrollTo({
          top: window.scrollY + rect.top - offset,
          behavior: 'smooth',
        });
        if (typeof first.focus === 'function') {
          first.focus({ preventScroll: true });
        }
      });
    }, true);
  }

  prefillEmailFromQuery() {
    let email = null;
    try {
      email = new URLSearchParams(window.location.search).get('email');
    } catch (e) {
      email = null;
    }
    if (!email) return;
    const trimmed = email.trim();
    if (!trimmed) return;
    const input = this.form.querySelector('[data-tag="email"]');
    if (!input) return;
    input.value = trimmed;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  setupBirthdatePlaceholder() {
    const birthdateInput = this.form.querySelector('[data-tag="birthdate"]');
    if (!birthdateInput) return;
    birthdateInput.addEventListener('change', () => {
      birthdateInput.classList.toggle('placeholder', birthdateInput.value === '');
    });
  }

  setupDrawerCloseCookie() {
    const formWrapper = document.querySelector('.newsletter-form');
    formWrapper?.nextElementSibling?.addEventListener('click', () => {
      this.setNewsletterCookie();
    });
  }

  setupPopupTimer() {
    if (!this.formPopup || this.checkNewsletterCookie() || !this.newsletterFormFooter?.hasAttribute('data-display')) return;
    const displayTime = parseFloat(this.newsletterFormFooter.dataset.display);
    if (!Number.isNaN(displayTime) && displayTime > 0) {
      setTimeout(() => this.openNewsletterPopup(), displayTime * 1000);
    }
  }

  checkNewsletterCookie() {
    return document.cookie.split(';').some((item) => {
      const t = item.trim();
      return (
        t.startsWith('newsletterPopupClosed=') || t.startsWith('antonioliTeaserSuppressed=')
      );
    });
  }

  setNewsletterCookie() {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `newsletterPopupClosed=true; expires=${expiryDate.toUTCString()}; path=/`;
  }

  openNewsletterPopup() {
    if (this.formPopup && this.newsletterFormFooter) {
      this.newsletterFormFooter.click();
      this.setNewsletterCookie();
    }
  }

  closeNewsletterPopup() {
    if (this.formPopup) this.formPopup.style.display = 'none';
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const formTags = this.form.querySelector('[data-tag="tags"]');
    if (!formTags) return;

    const tags = ['newsletter', 'register', "antonioli_ecommerce", "source_newsletter"];

    this.form.querySelectorAll('[data-consent-tag]:checked').forEach((cb) => {
      const tag = cb.getAttribute('data-consent-tag');
      if (tag) tags.push(tag);
    });

    const firstName = this.form.querySelector('[data-tag="first-name"]')?.value;
    if (firstName) tags.push(`first-name_${firstName}`);

    const countryEl = this.form.querySelector('[data-tag="country"]');
    if (countryEl?.selectedIndex >= 0) {
      const opt = countryEl.options[countryEl.selectedIndex];
      const country = this.toIsocode3(opt?.value);
      if (country) tags.push(`country_${country}`);
    }

    const birthdate = this.form.querySelector('[data-tag="birthdate"]')?.value;
    if (birthdate) tags.push(`birthdate_${birthdate}`);

    const lastName = this.form.querySelector('[data-tag="last-name"]')?.value;
    if (lastName) tags.push(`last-name_${lastName}`);

    const phonePrefix = this.form.querySelector('[data-tag="phone_prefix"]')?.value;
    if (phonePrefix) tags.push(`prefix_${phonePrefix}`);
    const phone = this.form.querySelector('[data-tag="phone"]')?.value;
    if (phone) tags.push(`phone_${phone}`);

    const nameStore = this.form.querySelector('[data-tag="name_store"]');
    const boutiquesSelect = this.form.querySelector('.chose-boutiques .botiques');
    if (nameStore && boutiquesSelect?.selectedIndex >= 0) {
      tags.push(nameStore.value);
      tags.push(`boutiquepreference_${boutiquesSelect.options[boutiquesSelect.selectedIndex].value.toLowerCase()}`);
      const city = this.form.querySelector('[data-tag="city"]')?.value;
      if (city && typeof StringTransformer !== 'undefined') {
        tags.push(`city_${new StringTransformer(city).transform()}`);
      }
    }

    const title = this.form.querySelector('[data-tag="title"]')?.value;
    if (title) tags.push(`title_${title}`);

    formTags.value = tags.join(',');
    this.form.submit();
  }

   toIsocode3(iso2) {
    return { AD: "AND", AE: "ARE", AF: "AFG", AG: "ATG", AI: "AIA", AL: "ALB", AM: "ARM", AO: "AGO", AQ: "ATA", AR: "ARG",
      AS: "ASM", AT: "AUT", AU: "AUS", AW: "ABW", AX: "ALA", AZ: "AZE", BA: "BIH", BB: "BRB", BD: "BGD", BE: "BEL",
      BF: "BFA", BG: "BGR", BH: "BHR", BI: "BDI", BJ: "BEN", BL: "BLM", BM: "BMU", BN: "BRN", BO: "BOL", BQ: "BES",
      BR: "BRA", BS: "BHS", BT: "BTN", BV: "BVT", BW: "BWA", BY: "BLR", BZ: "BLZ", CA: "CAN", CC: "CCK", CD: "COD",
      CF: "CAF", CG: "COG", CH: "CHE", CI: "CIV", CK: "COK", CL: "CHL", CM: "CMR", CN: "CHN", CO: "COL", CR: "CRI",
      CU: "CUB", CV: "CPV", CW: "CUW", CX: "CXR", CY: "CYP", CZ: "CZE", DE: "DEU", DJ: "DJI", DK: "DNK", DM: "DMA",
      DO: "DOM", DZ: "DZA", EC: "ECU", EE: "EST", EG: "EGY", EH: "ESH", ER: "ERI", ES: "ESP", ET: "ETH", FI: "FIN",
      FJ: "FJI", FK: "FLK", FM: "FSM", FO: "FRO", FR: "FRA", GA: "GAB", GB: "GBR", GD: "GRD", GE: "GEO", GF: "GUF",
      GG: "GGY", GH: "GHA", GI: "GIB", GL: "GRL", GM: "GMB", GN: "GIN", GP: "GLP", GQ: "GNQ", GR: "GRC", GS: "SGS",
      GT: "GTM", GU: "GUM", GW: "GNB", GY: "GUY", HK: "HKG", HM: "HMD", HN: "HND", HR: "HRV", HT: "HTI", HU: "HUN",
      ID: "IDN", IE: "IRL", IL: "ISR", IM: "IMN", IN: "IND", IO: "IOT", IQ: "IRQ", IR: "IRN", IS: "ISL", IT: "ITA",
      JE: "JEY", JM: "JAM", JO: "JOR", JP: "JPN", KE: "KEN", KG: "KGZ", KH: "KHM", KI: "KIR", KM: "COM", KN: "KNA",
      KP: "PRK", KR: "KOR", KW: "KWT", KY: "CYM", KZ: "KAZ", LA: "LAO", LB: "LBN", LC: "LCA", LI: "LIE", LK: "LKA",
      LR: "LBR", LS: "LSO", LT: "LTU", LU: "LUX", LV: "LVA", LY: "LBY", MA: "MAR", MC: "MCO", MD: "MDA", ME: "MNE",
      MF: "MAF", MG: "MDG", MH: "MHL", MK: "MKD", ML: "MLI", MM: "MMR", MN: "MNG", MO: "MAC", MP: "MNP", MQ: "MTQ",
      MR: "MRT", MS: "MSR", MT: "MLT", MU: "MUS", MV: "MDV", MW: "MWI", MX: "MEX", MY: "MYS", MZ: "MOZ", NA: "NAM",
      NC: "NCL", NE: "NER", NF: "NFK", NG: "NGA", NI: "NIC", NL: "NLD", NO: "NOR", NP: "NPL", NR: "NRU", NU: "NIU",
      NZ: "NZL", OM: "OMN", PA: "PAN", PE: "PER", PF: "PYF", PG: "PNG", PH: "PHL", PK: "PAK", PL: "POL", PM: "SPM",
      PN: "PCN", PR: "PRI", PS: "PSE", PT: "PRT", PW: "PLW", PY: "PRY", QA: "QAT", RE: "REU", RO: "ROU", RS: "SRB",
      RU: "RUS", RW: "RWA", SA: "SAU", SB: "SLB", SC: "SYC", SD: "SDN", SE: "SWE", SG: "SGP", SH: "SHN", SI: "SVN",
      SJ: "SJM", SK: "SVK", SL: "SLE", SM: "SMR", SN: "SEN", SO: "SOM", SR: "SUR", SS: "SSD", ST: "STP", SV: "SLV",
      SX: "SXM", SY: "SYR", SZ: "SWZ", TC: "TCA", TD: "TCD", TF: "ATF", TG: "TGO", TH: "THA", TJ: "TJK", TK: "TKL",
      TL: "TLS", TM: "TKM", TN: "TUN", TO: "TON", TR: "TUR", TT: "TTO", TV: "TUV", TW: "TWN", TZ: "TZA", UA: "UKR",
      UG: "UGA", UM: "UMI", US: "USA", UY: "URY", UZ: "UZB", VA: "VAT", VC: "VCT", VE: "VEN", VG: "VGB", VI: "VIR",
      VN: "VNM", VU: "VUT", WF: "WLF", WS: "WSM", YE: "YEM", YT: "MYT", ZA: "ZAF", ZM: "ZMB", ZW: "ZWE",
    }[iso2];
  }

}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsLetterForm);
}



class PhonePrefixes extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('select');
    this.valueSpan = this.querySelector('[data-value]');
  }

  connectedCallback() {
    this.select.addEventListener('change', () => {
      this.selectPrefix(this.select.selectedIndex);
    });
  }

  selectPrefix(index) {
    const prefix = this.select.options[index].value.replace(/^\+/, '');
    this.valueSpan.textContent = '+' + prefix;
  }
}

if (!customElements.get('phone-prefixes')) {
  customElements.define('phone-prefixes', PhonePrefixes);
}